export default __webpack_public_path__ + "static/media/status-red.d0436340.png";